import {userActionTypes} from '../_constants';

export function registration(state = {}, action) {
  switch (action.type) {

    // user-registration cancellation or post user-registration success
    case userActionTypes.REGISTRATION_VALIDATE_USER_CLEAR:
      return {};
      
      // registration request is pending
    case userActionTypes.CREATE_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
      
      // registration request has ended
    case userActionTypes.CREATE_USER_SUCCESS:
    case userActionTypes.CREATE_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state
  }
}